import { HEADERS, LOYALTY_CODE_OPERATION, LOYALTY_ERROR_MESSAGES } from '@/utils/constants';
import { getConfig } from '@/utils/config/config';
import { fetchApi } from '@/lib/fetcher';

type LoyaltyCodeApiError = {
    $fault: 'client' | 'server';
    $metadata: {
        httpStatusCode: number;
        requestId: string;
        attempts: number;
        totalRetryDelay: number;
    };
    name: string;
    message: string;
    __type: string;
};

export const addLoyaltyCode = async (loyaltyCodeEndpoint: string, loyaltyCode: string): Promise<boolean> => {
    const apiUrl = `${loyaltyCodeEndpoint}/${LOYALTY_CODE_OPERATION.ADD}`;
    const networkConfig = getConfig().network?.InternalLoyaltyCodeClient;

    // @ts-ignore
    try {
        const response = await fetchApi(
            apiUrl,
            {
                method: 'GET',
                headers: {
                    [HEADERS.LOYALTY_CODE]: loyaltyCode
                },
                credentials: 'include'
            },
            networkConfig ? { networkConfig } : undefined
        );

        // success: 200 no body
        // failure: 200 with 400/failure status in body..
        const data = await response.text();
        if (response.status !== 200) {
            return Promise.reject(data);
        }

        if (data) {
            const res = JSON.parse(data) as LoyaltyCodeApiError;
            const errorMessage =
                res.name === LOYALTY_ERROR_MESSAGES.CONDITIONAL_CHECK_FAILED_EXCEPTION
                    ? 'Your Momentum account has already been linked, please try again using a different account'
                    : 'Could not save loyalty code, please try again';
            return Promise.reject(errorMessage);
        }

        return true;
    } catch (e) {
        console.error('Error adding loyalty code:', e);
        return Promise.reject('Could not save loyalty code, please try again');
    }
};

export const readLoyaltyCode = async (loyaltyCodeEndpoint: string): Promise<any> => {
    const apiUrl = `${loyaltyCodeEndpoint}/${LOYALTY_CODE_OPERATION.READ}`;
    const networkConfig = getConfig().network?.InternalLoyaltyCodeClient;

    try {
        const response = await fetchApi(
            apiUrl,
            {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json'
                }
            },
            networkConfig ? { networkConfig } : undefined
        );

        if (!response.ok) {
            throw new Error(`Failed to read loyalty code: ${response.status}`);
        }

        const text = await response.text();
        if (!text) {
            return null;
        }

        return JSON.parse(text);
    } catch {
        throw new Error('Could not retrieve loyalty code.');
    }
};
